import * as z from 'zod';

import { schema } from './';
import { inicialSchema } from './inicialSchema';
import { dependenteSchema } from '../../../Bussiness-steps/data/schema/functionarysSchema';
import { cadastradoSchema } from './functionarysSchema';

export const billetSchema = z.object({
  payment: z.optional(
    z.object({
      billetDate: z.optional(
        z.string().min(1, { message: 'Campo obrigatório' }),
      ),
      patrocinio: z.optional(z.string()),
      aceite: z.boolean(),
    }),
  ),

  user: z.optional(schema),
  inicial: z.optional(inicialSchema),
  cadastrado: z.optional(cadastradoSchema),
  newDependents: z.optional(z.array(dependenteSchema)),
});

export type BilletSchema = z.infer<typeof billetSchema>;
